module.exports = __webpack_public_path__ + "../resources/img/line_checkbox_selected_lt_hover.1dc83ac5.svg";